<template>
<div class="content custom-scroll" >
    <p-entry v-for="(entry, index) in entriesPro" :key="index" :entry="entriesPro[index]" @click.native="openSlideover($event, index)"></p-entry>
    <!-- <p v-if="selectedPro">pro</p>
    <p v-if="!selectedPro">personal</p> -->
</div>
</template>

<script>
import PEntry from './PEntry.vue';
import entriesPro from './../assets/entries_pro.json'
export default {
    props: ['selectedPro'],
    components: {
        'p-entry': PEntry
    },
    data() {
        return {
            entriesPro
        }
    },
    methods: {
        openSlideover(event, index) {
            this.$emit('openSlideover', this.entriesPro[index]);
            // this.entriesPro[index].hideArrow = true;
            // setTimeout(() => {
            //     this.entriesPro[index].hideArrow = false;
            // }, 5000);

        }
    },
    created() {
        // console.log(this.entriesPro);
    }
    
}
</script>

<style scoped lang="scss">
.content {
    padding-top: 150px;
    position: relative;
    padding: 0 70px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
}

@media screen and (max-width: 810px) {
    .content {
        padding: 0 30px;
    }
}
</style>